import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatCalendar, MatCalendarUserEvent, MatDateRangePicker } from '@angular/material/datepicker';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-custom-header-date-range-picker',
  templateUrl: './custom-header-date-range-picker.component.html',
  styleUrls: ['./custom-header-date-range-picker.component.scss'],
})
export class CustomHeaderDateRangePickerComponent<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    private _dateRangePicker: MatDateRangePicker<D>,
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    cdr: ChangeDetectorRef,
  ) {
    _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
  }

  public todayClicked() {
    const today = new Date();
    this._calendar.activeDate = this._dateAdapter.createDate(
      today.getUTCFullYear(),
      today.getUTCMonth(),
      today.getDate(),
    );
    this._calendar._dateSelected(this._calendar.activeDate as unknown as MatCalendarUserEvent<D>);
    this._dateRangePicker?.select(this._calendar.activeDate);
    this._dateRangePicker?.select(this._calendar.activeDate);
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }
}
